<template>
  <div
    v-if="family?.subfamilies"
    class="sub-family-filter-selector rounded-xl shadow-md p-1 mb-3"
    :qaid="`sub-family-filter-selector-${family?.familyCode}`"
  >
    <div class="flex justify-between items-center mb-2">
      <div class="text-md font-normal" qaid="current-selection-type">{{ subFamilyLabel }}</div>
      <sub-family-learn-more-link
        v-if="isShowingDescriptionDialog"
        :sub-families-with-descriptions="subFamiliesWithDescriptions"
        :learn-more-dialog-title="subFamilyLabel"
      />
    </div>
    <sub-family-filter-selector-card
      v-for="(item, index) in family.subfamilies"
      :key="item.familyName"
      v-model="localValue"
      :group-name="family.familyCode"
      :subfamily="item"
      :qaid="`sub-family-selector-card-${index}`"
    />
  </div>
</template>

<script>
import SubFamilyFilterSelectorCard from '@/components/containers/buy-zone/SubFamilyFilterSelectorCard.vue';
import SubFamilyLearnMoreLink from '@/familyDetailsPage/components/SubFamilyLearnMoreLink.vue';

export default {
  components: {
    SubFamilyFilterSelectorCard,
    SubFamilyLearnMoreLink,
  },

  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    family: {
      type: Object,
      required: true,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    subFamilyLabel() {
      return this.family?.subfamilyLabel;
    },
    subFamiliesWithDescriptions() {
      let descriptions = [];
      this.family?.subfamilies?.forEach((subFamily) => {
        if (subFamily.intro) {
          descriptions.push(subFamily);
        }
      });
      return descriptions;
    },
    isShowingDescriptionDialog() {
      return (
        this.subFamiliesWithDescriptions?.length &&
        (this.subFamilyLabel
          .toLowerCase()
          .includes(this.$t('type.EnumSubFamilyTitle.SubfamilyTitle1.name').toLowerCase()) ||
          this.subFamilyLabel
            .toLowerCase()
            .includes(this.$t('type.EnumSubFamilyTitle.SubfamilyTitle2.name').toLowerCase()))
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.sub-family-filter-selector {
  :deep(.sub-family-option-card:last-child) {
    .pdl-card {
      margin-bottom: 0;
    }
  }
}
</style>
